import React, { useState, useLayoutEffect } from 'react';
import ReactPlayer from 'react-player';
import { useSelector } from 'react-redux';
import { getNavbarHeight, getViewportDimensions, keepSpaceTogether, getImageFilepath } from '../../../../models/Utils';

import './VideoBanner.scss';

import Arrow from '../../../Common/Arrow/Arrow';
import { useMediaQuery } from 'react-responsive';
import { ADAARIARoles } from '../../../../models/ADA';

const videoRatio = 16 / 9;
const togetherString = 'V Team';

const VideoBanner = React.forwardRef((props, theRef) => {
  const [ heightParams, setHeightParams ] = useState({ marginTop: 0, height: 0 });
  const [ videoDimensions, setVideoDimensions ] = useState({ width: 0, height: 0 });
  const videoTimeout = useSelector(state => state.data.videoFadeTimeout);
  const [ isPlaying, setIsPlaying ] = useState(false);
  const [ hasStarted, setHasStarted ] = useState(false);
  const menuOpened = useSelector(state => state.data.menuOpened);
  const isDesktopView = useMediaQuery({ query: '(min-width: 767px)' });
  const mediaPath = useSelector(state => state.config.basePath + state.config.apiMediaPath);

  const handleResize = () => {
    const marginTop = getNavbarHeight();
    const viewport = getViewportDimensions();
    const height = viewport.height - marginTop;
    setHeightParams({
      marginTop,
      height,
    });
    const width = viewport.width;
    if (width / height > videoRatio) {
      // width of the video should be the same
      setVideoDimensions({
        width: width,
        height: width / videoRatio
      });
    } else {
      // height of the video should be the same
      setVideoDimensions({
        width: height * videoRatio,
        height: height
      });
    }
  };

  const loopVideo = () => {
    if (!isPlaying) {
      setIsPlaying(true);
    }
  };
  
  function delayedVideoFade() {
    setTimeout(handleVideoStart, videoTimeout);
  }

  const handleVideoStart = () => {
    setHasStarted(true);
  };

  useLayoutEffect(() => {
    handleResize();

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  //console.log(props)

  var video = (
    <div className="bbf-vb-video" role="img" alt={props.bgndVideo.AltText} >
          <ReactPlayer
            url={props.bgndVideo.BackgroundMedia ? mediaPath + props.bgndVideo.BackgroundMedia : props.bgndVideo.URL}
            //url={'https://www.youtube.com/embed/jNo82YnmsgA'}
            width={videoDimensions.width}
            height={videoDimensions.height}
            muted={true}
            loop={true}
            playing={isPlaying}
            volume={0}
            config={{
              youtube: props.bgndVideo.URL.indexOf("youtube.com") < 0 ? null : {
                playerVars: {
                  autoplay: 1,
                  showinfo: 0
                },
                onUnstarted: () => loopVideo()
              }
            }}
            onReady={ () => loopVideo() }
            onStart={handleVideoStart}
          />
          <div
            className={`bbf-vb-video-blocker ${isPlaying && hasStarted ? '' : 'video-not-playing'}`}
            style={{
              backgroundColor: props.bgndVideo.Overlay || null,
              opacity: props.bgndVideo.Opacity || 0
            }}
          ></div>
    </div>
  );

    var imagePlaceholder = props.bgndVideo.BackgroundMedia ? (
    <img src={mediaPath + getImageFilepath(props.bgndVideo.BackgroundMedia)}
          className="background-image"/>
  ) : null;

  return (
    <div
      className="bbf-video-banner"
      ref={theRef}
      style={{
        backgroundImage: props.bgndImage ? `url("${props.bgndImage}")` : null,
        marginTop: `${heightParams.marginTop}px`,
        height: `${heightParams.height}px` }}
    >
      {
        props.bgndVideo.BackgroundMedia ?
          props.bgndVideo.BackgroundMedia.split(".").pop() === "mp4" ?
          video : imagePlaceholder
        : video
      }
      <div className="bbf-vb-wrapper cpvi-grid-container">
        <div className="cpvi-grid-row">
          <div className={`bbf-vb-text-content ${props.bigFont ? 'big' : ''} cpvi-grid-col w6`}>
            {
              props.title && 
              (<h1 className="bbf-vb-title" role={ADAARIARoles.Heading} >{keepSpaceTogether(props.title, togetherString)}</h1>)
            }
            {
              props.text &&
              (<React.Fragment>
                <p className="bbf-vb-text desktop">{keepSpaceTogether(props.text, togetherString)}</p>
                <p className="bbf-vb-text mobile cont-75" >{keepSpaceTogether(props.text, togetherString)}</p>
              </React.Fragment>)
            }
          </div>
        </div>
      </div>
      <div className="bbf-vb-arrow">
        <Arrow direction="down" darkMode={true} width="10px" handleClick={props.onGoDown} />
      </div>
    </div>
  );
});

export default VideoBanner;
